import { CUSTOM_FIELDS_VISITOR_FILTERS } from "~/app/sales/leads/constants";
import configuration from "~/configuration";

import { ATTRIBUTE_TYPE } from "~/core/constants/attributes";

import { faTable } from "@fortawesome/pro-light-svg-icons";
import {
  faCalendarDays,
  faCircleCaretDown,
  faHashtag,
  faLocationDot,
  faRectangleHistory,
  faSquareCheck,
  faSquareKanban,
  faText,
} from "@fortawesome/pro-regular-svg-icons";

import type { GetOpportunityResponsesWithFilteringBody } from "../types/common";

export const OPPORTUNITY_ID_COLUMN_ID = "serial";
export const NO_STAGE_ID = "no_stage";

export const defaultOpportunityResponseQuery: GetOpportunityResponsesWithFilteringBody =
  {
    page: 1,
    limit: 50,
    filters: [],
    q: "",
  };

export const OPPORTUNITY_VIEW_LOCAL_STORAGE_KEY = `opportunity_view__${configuration.environment}`;

export const OPPORTUNITY_VIEW = {
  TABLE: "table",
  KANBAN: "kanban",
} as const;

export const OPPORTUNITY_VIEWS = [
  {
    id: OPPORTUNITY_VIEW.TABLE,
    title: "",
    faIcon: faTable,
  },
  {
    id: OPPORTUNITY_VIEW.KANBAN,
    title: "",
    faIcon: faSquareKanban,
  },
];

export const TEXT_CONDITION = [
  { label: "contain", value: "contain" },
  { label: "not contain", value: "not_contain" },
  { label: "starts with", value: "starts_with" },
  { label: "ends with", value: "ends_with" },
  { label: "is", value: "is" },
  { label: "is not", value: "is_not" },
  { label: "empty", value: "empty" },
  { label: "not empty", value: "not_empty" },
];

export const NUMBER_CONDITION = [
  { label: "is", value: "is" },
  { label: "is not", value: "is_not" },
  { label: "greater than", value: "greater_than" },
  { label: "less than", value: "less_than" },
  { label: "empty", value: "empty" },
  { label: "not empty", value: "not_empty" },
];

export const SELECT_CONDITION = [
  { label: "is", value: "is" },
  { label: "is not", value: "is_not" },
  { label: "empty", value: "empty" },
  { label: "not empty", value: "not_empty" },
];

export const PAGE_VISIT_CONDITION = [
  { label: "Include All", value: "include_all" },
  { label: "Exclude All", value: "exclude_all" },
];

export const DATE_CONDITION = [
  { label: "is", value: "is" },
  { label: "is not", value: "is_not" },
  { label: "before", value: "before" },
  { label: "after", value: "after" },
  { label: "empty", value: "empty" },
  { label: "not empty", value: "not_empty" },
];

export const CHECKBOX_CONDITION = [
  { label: "yes", value: "is" },
  { label: "no", value: "is_not" },
];

export const FIELD_ID_FILTER_CHIP_LABEL_MAPPING = {
  [CUSTOM_FIELDS_VISITOR_FILTERS.custom_visited_pages]: "page",
};

export const COLUMN_NAME = {
  OPPORTUNITY_STAGE: "opportunity_stage",
  OPPORTUNITY_ACCOUNT: "opportunity_account",
  OPPORTUNITY_OTHER_STAKEHOLDERS: "opportunity_other_stakeholders",
  OPPORTUNITY_CONTACT: "opportunity_contact",
  OPPORTUNITY_OWNER: "opportunity_owner",
};

export const DYNAMIC_VALUES_STATUS = {
  NOT_TRIGGERED: "NOT_TRIGGERED",
  FETCH: "FETCH",
  FETCHING: "FETCHING",
  DONE: "DONE",
};

export const SYSTEM_COLUMN_NAME = {
  CONTACT: "opportunity_contact",
  ACCOUNT: "opportunity_account",
  STAGE: "opportunity_stage",
  OWNER: "opportunity_owner",
  OTHER_STAKEHOLDERS: "opportunity_other_stakeholders",
};

export const OPPORTUNITIES_RIGHT_SIDEBAR_WIDTH_KEY =
  "opportunitiesRightSidebarWidth";

export const DEFAULT_CONDITION = {
  string: {
    placeholder: "contain",
    value: "contain",
  },
  location: {
    placeholder: "contain",
    value: "contain",
  },
  number: {
    placeholder: "greater then",
    value: "greater_than",
  },
  date: {
    placeholder: "after",
    value: "after",
  },
  timestamp: {
    placeholder: "after",
    value: "after",
  },
  select: {
    placeholder: "is",
    value: "is",
  },
  multi_select: {
    placeholder: "is",
    value: "is",
  },
  visited_pages: {
    placeholder: "include all",
    value: "include_all",
  },
  date_range: {
    placeholder: "between",
    value: "between",
  },
};

export const EMPTY_CONDITION = {
  EMPTY: "empty",
  NOT_EMPTY: "not_empty",
};

export const CREATED_BY = {
  SYSTEM: "system",
};

export const FIELD_TO_ICON_MAPPING = {
  [ATTRIBUTE_TYPE.STRING]: faText,
  [ATTRIBUTE_TYPE.NUMBER]: faHashtag,
  [ATTRIBUTE_TYPE.DATE]: faCalendarDays,
  [ATTRIBUTE_TYPE.CHECKBOX]: faSquareCheck,
  [ATTRIBUTE_TYPE.SELECT]: faCircleCaretDown,
  [ATTRIBUTE_TYPE.MULTI_SELECT]: faRectangleHistory,
  [ATTRIBUTE_TYPE.LOCATION]: faLocationDot,
};

export enum OpportunitiesRightSidebarTabKeys {
  ACTIVITIES = "opportunities-right-sidebar-activities",
  EMAILS = "opportunities-right-sidebar-emails",
  NOTES = "opportunities-right-sidebar-notes",
  FILES = "opportunities-right-sidebar-files",
  CONTACTS = "opportunities-right-sidebar-contacts",
  FORMS = "opportunities-right-sidebar-forms",
  DOCUSIGN = "opportunities-right-sidebar-docusign",
}
